import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

const authPersistConfig = {
  key: 'auth',
  storage: storage,
  blacklist: []
}

// Persist page filters and sort so they survive a page reload. sessionStorage
// keeps them for the current browser session (reset when the tab/browser closes),
// and autoMergeLevel2 lets filter groups/fields added later fall back to their
// defaults instead of being dropped. Transient UI state (open filter panel,
// activity-map selection) is excluded.
const pageStorePersistConfig = {
  key: 'pageStore',
  storage: storageSession,
  stateReconciler: autoMergeLevel2,
  blacklist: ['filterOpened', 'filterSelected'],
};

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'settings',
    'credentials',
    'globalContext',
  ],
};

export { authPersistConfig, pageStorePersistConfig, persistConfig };
